import { ThemeUIStyleObject } from 'theme-ui'

export const fonts = {
  body: 'Poppins, system-ui, sans-serif',
  heading: 'Poppins, system-ui, sans-serif',
  monospace: 'Menlo, monospace',
}

export const fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 96]

export const fontWeights = {
  body: 400,
  heading: 600,
  bold: 700,
}
